var React = require('react');

function Rocket (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"currentColor","strokeWidth":"1.5","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M13.956 7.105A8 8 0 0 1 19.364 5h.386v.386a8 8 0 0 1-2.105 5.408l-6.15 6.704-4.243-4.243 6.704-6.15zM7.75 17l-2.5 2.5M9.75 19l-.5.5M5.75 15l-.5.5M13.5 19.5l1.24-5.25-3.24 3.25zM7.25 13.25 10.5 10l-5.25 1z"})));
}

Rocket.defaultProps = {"width":"24","height":"24"};

module.exports = Rocket;

Rocket.default = Rocket;
